import React, { useEffect, useState } from "react";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import Card from "../../share/cards/Card";
import CoustomTable from "../../share/Table/CoustomTable";
import { Modal } from "../../share/modal/Modal";
import ModalIdea from "../StudentCourse/ModalIdea";
import { Bar, Chart } from "react-chartjs-2";
import { defaults } from "chart.js";
import RechargeModal from "../dashboard/RechargeModal";
import WithdrawModal from "../dashboard/WithdrawModal";
import InoviceModal from "../dashboard/InoviceModal";
import ShebaModal from "../dashboard/ShebaModal";
import ShebaConfirmModal from "../dashboard/ShebaConfirmModal";
import WithdrawPriceModal from "../dashboard/WithdrawPriceModal";
import RechargeConfirmModal from "../dashboard/RechargeConfirmModal";
import useFetch from "../../../Hooks/useFetch";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import MainPagination from "../../share/Pageination/MainPagination";

function Finance() {
    const [barData, setBarData] = useState(1);
    const [courseId, setCourseId] = useState();
    const [modalData, setModalData] = useState();
    const [modalbtn, setModalbtn] = useState(false);
    const [withdrawModalBtn, setWithdrawModalBtn] = useState(false);
    const [withdrawModalStep, setWithdrawModalStep] = useState(0);
    const [rechargeModalBtn, setRechargeModalBtn] = useState(false);
    const [rechargeModalStep, setRechargeModalStep] = useState(0);
    const [inoviceModalBtn, setInoviceModalBtn] = useState(false);
    const [paymentModalBtn, setPaymentModalBtn] = useState(false);
    const [transactionsPage, setTransactionsPage] = useState(0);
    const [coloumn, setColoumn] = useState(3);
    const transactionsTableStart = transactionsPage * coloumn;
    const transactionsTableEnd = transactionsPage * coloumn + coloumn;
    const [courses, setCourses] = useState();

    const [pagination, setPagination] = useState({
        current: 1,
    });

    useEffect(() => {
        draftCourse.reFetch();
    }, [pagination]);

    const draftCourse = useFetch({
        method: "GET",
        url: "BootCampService/admin_draft_bootcamp",
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });

    const showModal = () => {
        setModalbtn(true);
    };
    const showWithdrawModal = () => {
        setWithdrawModalBtn(true);
    };
    const showRechargeModal = () => {
        setRechargeModalBtn(true);
    };
    const showInoviceModal = (id) => {
        // console.log(num);
        setInoviceModalBtn(true);
        setCourseId(id);
    };

    // useEffect(() => {
    //     console.log(courses?.results);
    // }, [courses]);

    useEffect(() => {
        courses?.results.map(
            (course) => course.id == courseId && setModalData(course)
        );
    }, [courseId]);

    const showPaymentModal = () => {
        setPaymentModalBtn(true);
    };

    let data = {
        labels:
            barData == 1
                ? barData1?.map((data) => data.month)
                : barData2?.map((data) => data.month),
        datasets: [
            {
                id: 1,
                label: "درآمد",
                data:
                    barData == 1
                        ? barData1?.map((data) => data.gain)
                        : barData2?.map((data) => data.gain),
                backgroundColor: ["#EAD0AD"],
            },
            {
                id: 2,
                label: "پرداخت",
                data:
                    barData == 1
                        ? barData1?.map((data) => data.lose)
                        : barData2?.map((data) => data.lose),
                backgroundColor: ["#D8AECA"],
            },
        ],
    };

    return (
        <div className="SupportTicket">
            <h3 className="text-[1.6rem] font-bold mb-4">
                اطلاعات کلی کیف پول
            </h3>
            <Card className="flex flex-row px-10 py-11 items-center justify-between">
                <div className="flex flex-col">
                    <div className="flex flex-row gap-32">
                        <span className="text-purple text-[1.6rem] font-bold mb-16">
                            موجودی کیف پول
                        </span>
                        <span className="text-purple text-[1.6rem] font-bold">
                            1,500,000 تومان
                        </span>
                    </div>
                    <div className="flex flex-col gap-7 text-gray self-start">
                        <div className="flex flex-row text-[1.4rem] font-bold gap-[10.5rem]">
                            <p>مجموع هزینه‌ها</p>
                            <p>1,500,000 تومان</p>
                        </div>
                        <div className="flex flex-row text-[1.4rem] font-bold gap-[11.5rem]">
                            <p>مجموع واریزها</p>
                            <p>1,500,000 تومان</p>
                        </div>
                        <div className="flex flex-row text-[1.4rem] font-bold gap-[11rem]">
                            <p>مجموع درآمدها</p>
                            <p>1,500,000 تومان</p>
                        </div>
                    </div>
                </div>
                <div className="self-start">
                    <div className="flex flex-row">
                        <BtnPrimary
                            onClick={showRechargeModal}
                            text="شارژ کیف پول"
                            className=" py-4 px-6 ml-4"
                        />
                        <BtnAlternative
                            onClick={showWithdrawModal}
                            text="تسویه حساب"
                            className=" py-4 px-6"
                        />
                    </div>
                </div>
            </Card>
            <h4 className="text-[1.6rem] font-bold mt-16 mb-4">گزارش‌ها</h4>
            <Card className="flex flex-row px-6 py-11 items-center justify-between">
                <div className="flex flex-col gap-y-16 px-6 items-start">
                    <div>
                        <div className="text-gray text-[1.5rem] gap-[11rem] font-bold flex flex-row">
                            <p>درآمد کل</p>
                            <p>1,500,000 تومان</p>
                        </div>
                        <div className="text-gray text-[1.5rem] gap-[10.7rem] font-bold flex flex-row">
                            <p>هزینه کل</p>
                            <p>1,500,000 تومان</p>
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <div className="flex flex-row text-[1.4rem]  items-center gap-5 pb-5">
                            <div className="w-[35px] h-[35px] bg-[#EAD0AD] rounded-lg"></div>
                            <p className="ml-16">مجموع درآمد‌ها</p>
                            <p className="">1,500,000 تومان</p>
                        </div>
                        <div className="flex flex-row text-[1.4rem]  items-center gap-5">
                            <div className="w-[35px] h-[35px] bg-[#D8AECA] rounded-lg"></div>
                            <p className="ml-14">مجموع هزینه‌ها</p>
                            <p>1,500,000 تومان</p>
                        </div>
                    </div>
                    <div>
                        <BtnAlternative
                            text="دانلود گزارش"
                            className="px-10 py-6 self-center"
                        />
                    </div>
                </div>
                <div className="px-5">
                    <select
                        onChange={(e) => {
                            setBarData(e.target.value);
                        }}
                        className="font-bold max-w-full bg-transparent border-gray border-2 rounded-3xl w-full h-16 text-[1.1rem] text-gray mb-5"
                    >
                        <option value="1">
                            طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی
                        </option>
                        <option value="2">
                            طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های خصوصی
                        </option>
                    </select>
                    <Bar options={options} data={data} />
                </div>
            </Card>
            <h4 className="text-[1.6rem] font-bold mt-16">
                بوت کمپ‌های پیش‌نویس
            </h4>
            <div className="mx-5 py-12 text-[1.6rem]">
                {courses?.results &&
                    courses?.results.map((item) => (
                        <Card className="flex justify-between items-center mb-4 px-10 py-6">
                            {item.bootcamp_name}
                            <BtnAlternative
                                value={item.id}
                                text="پرداخت و انتشار"
                                className="px-10 py-5 self-center leading-tight"
                                onClick={(e) =>
                                    showInoviceModal(e.target.value)
                                }
                            />
                        </Card>
                    ))}
                <MainPagination
                    pagination={pagination}
                    setPagination={setPagination}
                    data={courses?.results}
                    pageSize={courses?.page_count}
                    className=" mt-[3rem]"
                />
            </div>
            <h4 className="text-[1.6rem] font-bold mt-16">تراکنش‌ها</h4>
            <CoustomTable
                list={list}
                showModal={showModal}
                header={header}
                lightbtn={true}
                btn={true}
                sort={false}
                priority={false}
                num={2}
                transactionsPage={transactionsPage}
                setTransactionsPage={setTransactionsPage}
                transactionsTableStart={transactionsTableStart}
                transactionsTableEnd={transactionsTableEnd}
            />
            <Modal show={modalbtn}>
                <ModalIdea close={setModalbtn} />
            </Modal>

            <Modal show={withdrawModalBtn}>
                {withdrawModalStep === 0 && (
                    <ShebaModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
                {withdrawModalStep === 1 && (
                    <ShebaConfirmModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
                {withdrawModalStep === 2 && (
                    <WithdrawPriceModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
                {withdrawModalStep === 3 && (
                    <WithdrawModal
                        setStep={setWithdrawModalStep}
                        step={withdrawModalStep}
                        close={setWithdrawModalBtn}
                    />
                )}
            </Modal>

            <Modal show={rechargeModalBtn}>
                {rechargeModalStep === 0 && (
                    <RechargeModal
                        close={setRechargeModalBtn}
                        step={rechargeModalStep}
                        setStep={setRechargeModalStep}
                    />
                )}
                {rechargeModalStep === 1 && (
                    <RechargeConfirmModal
                        close={setRechargeModalBtn}
                        step={rechargeModalStep}
                        setStep={setRechargeModalStep}
                    />
                )}
            </Modal>

            <Modal show={inoviceModalBtn}>
                <InoviceModal
                    close={setInoviceModalBtn}
                    // info={courses}
                    data={modalData}
                />
            </Modal>

            <Modal show={paymentModalBtn}>
                <InoviceModal close={setPaymentModalBtn} />
            </Modal>
        </div>
    );
}

export default Finance;

const list = [
    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "برداشت",
        date: "حق اشتراک ماهانه سرویس نقره‌ای اسکای‌روم",
        title: "رمینا",
        price: "1,000,000",
    },

    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "واریز",
        date: "ثبت نام بوت کمپ طراحی تبلیغات دیجیتالی برای سازمان های دولتی",
        title: "رمینا",
        price: "2,500,000",
    },

    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "برداشت",
        date: "تبلیغات پیامکی",
        title: "رمینا",
        price: "20,000",
    },
    {
        id: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
        name: "برداشت",
        date: "تبلیغات پیامکی",
        title: "رمینا",
        price: "20,000",
    },
];

const header = [
    { title: "نوع تراکنش" },
    { title: "عنوان" },
    { title: "تاریخ" },
    { title: "مبلغ" },
];

export const course = [
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 20,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 50,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 80,
    },
    {
        title: "طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی",
        teacher: "علی مهراندوست",
        category: "مارکتینگ",
        progress: 0,
    },
];

const barData1 = [
    {
        id: 1,
        month: "فروردین",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 1,
        month: "اردیبهشت",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 1,
        month: "خرداد",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 1,
        month: "تیر",
        gain: 100000,
        lose: 90000,
    },
];

const barData2 = [
    {
        id: 2,
        month: "فروردین",
        gain: 45000,
        lose: 60000,
    },
    {
        id: 2,
        month: "اردیبهشت",
        gain: 20000,
        lose: 10000,
    },
    {
        id: 2,
        month: "خرداد",
        gain: 100000,
        lose: 50000,
    },
    {
        id: 2,
        month: "تیر",
        gain: 80000,
        lose: 30000,
    },
];

//Chart customizations
defaults.font.family = "Vazir";
defaults.color = "black";
defaults.borderColor = "black";

export const options = {
    scales: {
        xAxis: {
            grid: { display: false },
        },
        yAxis: {
            grid: { display: false },
            title: { display: true, text: "مبلغ (تومان)" },
        },
    },
    responsive: true,
};
